<template>
    <div id="caido">
        <div class="container">
            <img class="logo" src="@/assets/isologotipo_chatpts_transparente.svg" alt="Logo de ChatPTS">
            <h1>¡En proceso de actualización!</h1>
            <p style="text-align: center;">
                Te pedimos disculpas. ¡Estamos en proceso de subir una nueva y mejorada versión de ChatPTS!
            </p>
            <p style="text-align: center;">
                En unos minutos podrás disfrutar de todas las novedades.
            </p>
        </div>
    </div>
</template>

<script>

export default {
    name: "ChatComponent",
    props: {
    },

    data() {
        return {
        };
    },
    watch: {

    },

    async mounted() {
    }
};
</script>

<style scoped>
#caido {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    /* background-color: #111; */
    background-size: cover;
    background-repeat: no-repeat;
    background-blend-mode: overlay;
    background-position: center;
    z-index: 0;
    background-color: white;
}

.logo {
        width: 400px;
    }

#caido::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.12);
    z-index: -1;
    /* Capa semi-transparente sobre la imagen */
}

#caido .container {
    width: 90%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 48px;
    border-radius: 24px;
    background-color: rgba(50, 50, 50, 0.85);
    color: #f0f0f0;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.6);
}

#caido h1 {
    font-weight: bold;
    text-align: center;
    margin: 24px 0;
    font-size: 28pt;
}

#caido h2 {
    font-weight: bold;
    margin-bottom: 24px;
    margin-top: 12px;
}

#caido p {
    margin-bottom: 24px;
    font-size: 20pt;
}

.login-footer-2 {
    padding-top: 24px;
    padding-bottom: 24px;
    color: #f0f0f0;

}

.login-footer-2 nav>* {
    margin: 12px;
}

/* MOBILE */
@media screen and (max-width: 768px) {
    #caido .container {
        width: 90%;
    }

    .logo {
        width: 85%;
    }

    #caido h1 {
        font-weight: bold;
        text-align: center;
        margin: 24px 0;
        font-size: 20pt;
    }

    #caido p {
        font-size: 16pt;
    }
}
</style>